(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/auth/_directives/alert.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/auth/_directives/alert.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngIf=\"message\" class=\"m-alert m-alert--outline alert alert-{{message.type}} alert-dismissible\" role=\"alert\">\r\n\t<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"></button>\r\n\t<span>{{message.text}}</span>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/auth/logout/logout.component.html":
/*!*****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/auth/logout/logout.component.html ***!
  \*****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/auth/templates/login-1.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/auth/templates/login-1.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row h-100\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row h-100\">\r\n      <div\r\n        class=\"col col-sm-12 col-md-4 d-flex justify-content-center align-items-center flex-column leftPanel\"\r\n      >\r\n        <!-- login form  -->\r\n        <div class=\"mt-auto w-100\">\r\n          <div class=\"col\">\r\n            <div class=\"col\">\r\n              <!-- <img\r\n                src=\"./../../../assets/logo.svg\"\r\n                style=\"max-width: 275px;\"\r\n                class=\"img-fluid\"\r\n              /> -->\r\n            </div>\r\n            <div class=\"col px-3 py-2 mb-3 text-justify\">\r\n              <h2>Scrapper Monitor</h2>\r\n            </div>\r\n            <form\r\n              class=\"px-3\"\r\n              (ngSubmit)=\"f.form.valid && signin(f)\"\r\n              #f=\"ngForm\"\r\n            >\r\n              <div class=\"form-group\">\r\n                <label for=\"exampleInputEmail1\">Username *</label>\r\n                <input\r\n                  type=\"text\"\r\n                  class=\"form-control\"\r\n                  required\r\n                  id=\"exampleInputEmail1\"\r\n                  aria-describedby=\"emailHelp\"\r\n                  placeholder=\"Username\"\r\n                  name=\"username\"\r\n                  [(ngModel)]=\"model.username\"\r\n                  #uname=\"ngModel\"\r\n                  autocomplete=\"off\"\r\n                />\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label for=\"exampleInputPassword\">Password *</label>\r\n                <input\r\n                  type=\"password\"\r\n                  required\r\n                  class=\"form-control\"\r\n                  \r\n                  placeholder=\"Password\"\r\n                  name=\"password\"\r\n                  [(ngModel)]=\"model.password\"\r\n                  #password=\"ngModel\"\r\n                />\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label for=\"exampleInputPassword1\">Secret Key *</label>\r\n                <input\r\n                  type=\"text\"\r\n                  required\r\n                  class=\"form-control\"\r\n                  \r\n                  placeholder=\"Your Secret Key\"\r\n                  name=\"secret_key\"\r\n                  #secretkey=\"ngModel\"\r\n                  [(ngModel)]=\"secret_key\"\r\n                />\r\n              </div><div class=\"form-group\">\r\n                <label for=\"exampleInputPassword2\">User Key *</label>\r\n                <input\r\n                  type=\"text\"\r\n                  required\r\n                  class=\"form-control\"\r\n                  \r\n                  placeholder=\"User Key\"\r\n                  name=\"user_key\"\r\n                  #userkey=\"ngModel\"\r\n                  [(ngModel)]=\"user_key\"\r\n                />\r\n              </div>\r\n\r\n              <div *ngIf=\"suberror.length\" >\r\n                <div *ngFor=\"let e of suberror\" class=\"alert alert-danger mt-3 mb-0\">\r\n                    {{e.err}}\r\n                </div>\r\n            </div>\r\n              <!-- disclaimer -->\r\n              <div class=\"mb-3 disclaimer\">\r\n                <h6>Disclaimer</h6>\r\n                <div class=\"overflow-auto disc-box\">\r\n                  <p>\r\n                    Love For Data , LFD, makes best-effort to present accurate\r\n                    and reliable information on its portal. LFD (SOLELY FOR\r\n                    PURPOSES OF INDEMNIFICATION, DISCLAIMER OF WARRANTIES, AND\r\n                    LIMITATION ON LIABILITY) DOES NOT MAKE AND HEREBY DISCLAIMS\r\n                    ANY WARRANTY, EXPRESS OR IMPLIED, WITH RESPECT TO THE LFD\r\n                    SERVICES. LFD DOES NOT WARRANT THE CORRECTNESS,\r\n                    COMPLETENESS, MERCHANTABILITY, OR FITNESS FOR A PARTICULAR\r\n                    PURPOSE OF THE LFD's LISTING SERVICES. Use of such\r\n                    information is voluntary, and reliance on it should only be\r\n                    undertaken after an independent review. Due to the nature of\r\n                    public record information, the public records and\r\n                    commercially available data sources used in the LFD's\r\n                    Listing Services may contain errors. Source data is\r\n                    sometimes reported or entered inaccurately, processed poorly\r\n                    or incorrectly, and is generally not free from defect. The\r\n                    LFD Listing Services are not the source of data. Therefore\r\n                    before relying on any data, it should be independently\r\n                    verified.\r\n                  </p>\r\n                  <p>\r\n                    LFD (including its employees and agents) assumes no\r\n                    responsibility for consequences resulting from the use of\r\n                    the information herein, or from use of the information\r\n                    obtained at linked websites, or in any respect for the\r\n                    content of such information, including (but not limited to )\r\n                    errors or omissions, the accuracy or reasonableness of\r\n                    factual or scientific assumptions, studies or conclusions,\r\n                    the defamatory nature of statements, ownership of copyright\r\n                    or other intellectual property rights, and the violation of\r\n                    property, privacy, or personal rights of others. LFD is not\r\n                    responsible for, and expressly disclaims all liability for,\r\n                    damages of any kind arising out of use, reference to, or\r\n                    reliance on such information. No guarantees or warranties,\r\n                    including (but not limited to) any express or implied\r\n                    warranties of merchantability or fitness for a particular\r\n                    use or purpose, are made by LFD with respect to such\r\n                    information.\r\n                  </p>\r\n                  <p>\r\n                    Regulated entities are ultimately responsible for determining\r\n                    the local definition of PEP for their respective geographies.\r\n                  </p>\r\n                </div>\r\n              </div>\r\n              <!-- disclaimer end -->\r\n              <div class=\"form-check\">\r\n                <input\r\n                  class=\"form-check-input\"\r\n                  type=\"checkbox\"\r\n                  required\r\n                  id=\"defaultCheck1\"\r\n                  name=\"disclaimer\"\r\n                  [(ngModel)]=\"disclaimer\"\r\n                />\r\n                <label class=\"form-check-label\" for=\"defaultCheck1\">\r\n                  I have read this agreement.\r\n                </label>\r\n              </div>\r\n              <small class=\"mute block\"\r\n                >*By clicking on agree you agree to our terms and\r\n                conditions.</small\r\n              >\r\n              <div class=\"mt-3\">\r\n                <button\r\n                  type=\"submit\"\r\n                  class=\"btn\"\r\n                  [disabled]=\"!model.username || !model.password || !disclaimer || !secret_key || !user_key\"\r\n                >\r\n                  Submit\r\n                </button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n        <!-- login form end -->\r\n        <!-- footer -->\r\n        <footer\r\n          class=\"footer mt-auto p-3 pl-4 pr-4 align-items-end w-100 text-muted\"\r\n        >\r\n          © 2019 Love For Data All Rights Reserved.\r\n        </footer>\r\n        <!-- footer end -->\r\n      </div>\r\n      <div class=\"col d-none d-sm-none d-md-block RightPanel\">\r\n        <div class=\"d-flex justify-content-center align-items-center h-100 \">\r\n          <img src=\"../../../assets/map.png\" />\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ngx-ui-loader fgsColor=\"#2E7D32\" pbColor=\"#2E7D32\"></ngx-ui-loader>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/no-internet/no-internet.component.html":
/*!**********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/no-internet/no-internet.component.html ***!
  \**********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  no-internet works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/p404/p404.component.html":
/*!********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/p404/p404.component.html ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"ep h-100\">\r\n  <div class=\"er\">404</div>\r\n  <div class=\"ertext\">Sorry! Page not found</div>\r\n  <button class=\"btn\">Login</button>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/p500/p500.component.html":
/*!********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/p500/p500.component.html ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"ep h-100\">\r\n  <div class=\"er\">500</div>\r\n  <div class=\"h4\">Internal Server error</div>\r\n  <div class=\"ertext\">Oops, Something went wrong<br/>contact server administrator</div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _auth_logout_logout_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./auth/logout/logout.component */ "./src/app/auth/logout/logout.component.ts");
/* harmony import */ var _p404_p404_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./p404/p404.component */ "./src/app/p404/p404.component.ts");
/* harmony import */ var _p500_p500_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./p500/p500.component */ "./src/app/p500/p500.component.ts");
/* harmony import */ var _no_internet_no_internet_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./no-internet/no-internet.component */ "./src/app/no-internet/no-internet.component.ts");







const routes = [
    { path: 'login', loadChildren: './auth/auth.module#AuthModule' },
    { path: 'logout', component: _auth_logout_logout_component__WEBPACK_IMPORTED_MODULE_3__["LogoutComponent"] },
    {
        path: '',
        loadChildren: './pages/pages.module#PagesModule',
    },
    {
        path: '404',
        component: _p404_p404_component__WEBPACK_IMPORTED_MODULE_4__["P404Component"]
    },
    {
        path: '500',
        component: _p500_p500_component__WEBPACK_IMPORTED_MODULE_5__["P500Component"]
    },
    {
        path: 'nointernet',
        component: _no_internet_no_internet_component__WEBPACK_IMPORTED_MODULE_6__["NoInternetComponent"]
    },
    {
        path: '**',
        redirectTo: '404'
    },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() {
        this.title = 'scrapperUI';
    }
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _p404_p404_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./p404/p404.component */ "./src/app/p404/p404.component.ts");
/* harmony import */ var _p500_p500_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./p500/p500.component */ "./src/app/p500/p500.component.ts");
/* harmony import */ var _no_internet_no_internet_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./no-internet/no-internet.component */ "./src/app/no-internet/no-internet.component.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _auth_auth_module__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./auth/auth.module */ "./src/app/auth/auth.module.ts");
/* harmony import */ var _shared_shared_module__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./shared/shared.module */ "./src/app/shared/shared.module.ts");
/* harmony import */ var _app_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./app.service */ "./src/app/app.service.ts");
/* harmony import */ var _pages_api_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./pages/api.service */ "./src/app/pages/api.service.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var ngx_filesaver__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ngx-filesaver */ "./node_modules/ngx-filesaver/fesm2015/ngx-filesaver.js");

















let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"],
            _p404_p404_component__WEBPACK_IMPORTED_MODULE_6__["P404Component"],
            _p500_p500_component__WEBPACK_IMPORTED_MODULE_7__["P500Component"],
            _no_internet_no_internet_component__WEBPACK_IMPORTED_MODULE_8__["NoInternetComponent"],
        ],
        imports: [
            _angular_forms__WEBPACK_IMPORTED_MODULE_9__["FormsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_10__["HttpClientModule"],
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            ngx_filesaver__WEBPACK_IMPORTED_MODULE_16__["FileSaverModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_3__["BrowserAnimationsModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            _auth_auth_module__WEBPACK_IMPORTED_MODULE_11__["AuthModule"],
            _shared_shared_module__WEBPACK_IMPORTED_MODULE_12__["SharedModule"].forRoot(),
            ngx_toastr__WEBPACK_IMPORTED_MODULE_15__["ToastrModule"].forRoot()
        ],
        providers: [_app_service__WEBPACK_IMPORTED_MODULE_13__["AppService"], _pages_api_service__WEBPACK_IMPORTED_MODULE_14__["ApiService"]],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/app.service.ts":
/*!********************************!*\
  !*** ./src/app/app.service.ts ***!
  \********************************/
/*! exports provided: AppService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppService", function() { return AppService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../environments/environment */ "./src/environments/environment.ts");





// import 'rxjs/add/operator/catch';

// import 'rxjs/add/observable/throw';
// import { WebConfig } from './WebConfig';

let AppService = class AppService {
    constructor(http, _router) {
        this.http = http;
        this._router = _router;
        this._config = _environments_environment__WEBPACK_IMPORTED_MODULE_6__["environment"];
        this.url = this._config.LFD;
    }
    get(_apiUrl, item) {
        return this.http.get(`${this.url}` + _apiUrl, this._header(item)).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(this.extractData), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    post(_apiUrl, item) {
        return this.http.post(`${this.url}` + _apiUrl, item.data, this.p_header(item)).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(this.extractData), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    patch(_apiUrl, item) {
        return this.http.patch(`${this.url}` + _apiUrl, item, this._header()).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(this.extractData), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    put(_apiUrl, itemId, item) {
        return this.http.put(`${this.url}` + _apiUrl + itemId, item.data, this._header(item)).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(this.extractData), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    put1(_apiUrl, item) {
        return this.http.put(`${this.url}` + _apiUrl, item.data, this._header(item)).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(this.extractData), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    delete(_apiUrl, item) {
        return this.http.delete(`${this.url}` + _apiUrl + item, this._header()).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(this.extractData), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    _header(hparam) {
        let user = localStorage.getItem('currentUser');
        if (!!user) {
            let temp = JSON.parse(user);
            let token = temp['token'];
            const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({
                // 'Access-Control-Allow-Origin': 'http://localhost:4200',
                // 'Access-Control-Allow-Credentials': 'true',
                // 'Access- Control-Allow-Headers': 'X-Requested-With, Content-Type',
                // 'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, DELETE',
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'jwt ' + token,
                'Signature': hparam.hmac_sig,
                'Key': hparam.u_key,
                'Timestamp': hparam.timestamp,
            });
            const options = { headers: headers };
            return options;
        }
    }
    p_header(itm) {
        let user = localStorage.getItem('currentUser');
        if (!!user) {
            let temp = JSON.parse(user);
            let token = temp['token'];
            const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({
                // 'Access-Control-Allow-Origin': 'http://localhost:4200',
                // 'Access-Control-Allow-Credentials': 'true',
                // 'Access- Control-Allow-Headers': 'X-Requested-With, Content-Type',
                // 'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, DELETE',
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'jwt ' + token,
                'Signature': itm.hmac_sig,
                'Key': itm.u_key,
                'timestamp': itm.timestamp,
                'Pragma': 'no-cache',
                'Cache-Control': 'no-cache, no-store, max-age=0, must-revalidate'
            });
            const options = { headers: headers };
            return options;
        }
    }
    extractData(res) {
        let body = res;
        return body;
    }
    handleError(error) {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(error);
    }
};
AppService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AppService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Injectable"])()
], AppService);



/***/ }),

/***/ "./src/app/auth/_directives/alert.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/auth/_directives/alert.component.ts ***!
  \*****************************************************/
/*! exports provided: AlertComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertComponent", function() { return AlertComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_services/index */ "./src/app/auth/_services/index.ts");



let AlertComponent = class AlertComponent {
    constructor(_alertService) {
        this._alertService = _alertService;
    }
    ngOnInit() {
        this._alertService.getMessage().subscribe(message => {
            this.message = message;
        });
    }
};
AlertComponent.ctorParameters = () => [
    { type: _services_index__WEBPACK_IMPORTED_MODULE_2__["AlertService"] }
];
AlertComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-alert',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./alert.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/auth/_directives/alert.component.html")).default
    })
], AlertComponent);



/***/ }),

/***/ "./src/app/auth/_guards/auth.guard.ts":
/*!********************************************!*\
  !*** ./src/app/auth/_guards/auth.guard.ts ***!
  \********************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_user_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../_services/user.service */ "./src/app/auth/_services/user.service.ts");




let AuthGuard = class AuthGuard {
    constructor(_router, _userService) {
        this._router = _router;
        this._userService = _userService;
    }
    canActivate(route, state) {
        if (!!localStorage.getItem('currentUser') == true) {
            return true;
        }
        this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
};
AuthGuard.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_user_service__WEBPACK_IMPORTED_MODULE_3__["UserService"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AuthGuard);



/***/ }),

/***/ "./src/app/auth/_services/alert.service.ts":
/*!*************************************************!*\
  !*** ./src/app/auth/_services/alert.service.ts ***!
  \*************************************************/
/*! exports provided: AlertService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertService", function() { return AlertService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");




let AlertService = class AlertService {
    constructor(_router) {
        this._router = _router;
        this.subject = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        this.keepAfterNavigationChange = false;
        // clear alert message on route change
        _router.events.subscribe(event => {
            if (event instanceof _angular_router__WEBPACK_IMPORTED_MODULE_2__["NavigationStart"]) {
                if (this.keepAfterNavigationChange) {
                    // only keep for a single location change
                    this.keepAfterNavigationChange = false;
                }
                else {
                    // clear alert
                    this.subject.next();
                }
            }
        });
    }
    success(message, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'success', text: message });
    }
    error(message, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'danger', text: message });
    }
    getMessage() {
        return this.subject.asObservable();
    }
};
AlertService.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AlertService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AlertService);



/***/ }),

/***/ "./src/app/auth/_services/authentication.service.ts":
/*!**********************************************************!*\
  !*** ./src/app/auth/_services/authentication.service.ts ***!
  \**********************************************************/
/*! exports provided: AuthenticationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationService", function() { return AuthenticationService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var src_app_shared_services_layout_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/shared/services/layout.service */ "./src/app/shared/services/layout.service.ts");



// import { WebConfig } from '../../WebConfig';
// import { Helpers } from '../../helpers';




// import 'rxjs/add/operator/catch';
// import 'rxjs/add/observable/throw';
// import { map } from 'rxjs/operators';
let AuthenticationService = class AuthenticationService {
    constructor(http, layoutService) {
        this.http = http;
        this.layoutService = layoutService;
        this.config = _environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"];
    }
    login(username, password) {
        let url = this.config.LFD + 'api-token-auth/';
        // let headers = new Headers({ 'Content-Type': 'application/json' });
        const httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
                'Content-Type': 'application/json',
                'Pragma': 'no-cache',
                'Cache-Control': 'no-cache, no-store, max-age=0, must-revalidate'
            })
        };
        return this.http.post(url, { username: username, password: password }, httpOptions)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])((res) => {
            return res;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((e, caught) => Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(this.errorHandler(e))));
    }
    errorHandler(error) {
        return error;
    }
    isAuth() {
        const user = localStorage.getItem('currentUser');
        return !!user;
    }
    logout() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('user_seckey');
        localStorage.removeItem('user_lkey');
        this.layoutService.rsToggleStatus.next(false);
    }
};
AuthenticationService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: src_app_shared_services_layout_service__WEBPACK_IMPORTED_MODULE_6__["LayoutService"] }
];
AuthenticationService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AuthenticationService);



/***/ }),

/***/ "./src/app/auth/_services/getIPaddress.service.ts":
/*!********************************************************!*\
  !*** ./src/app/auth/_services/getIPaddress.service.ts ***!
  \********************************************************/
/*! exports provided: IPAddressService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IPAddressService", function() { return IPAddressService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");






let IPAddressService = class IPAddressService {
    constructor(http) {
        this.http = http;
        this._config = src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"];
        this.publicip = this._config.public_ip;
    }
    getIpAddress() {
        return this.http
            .get('https://api.ipify.org/?format=json')
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(this.extractData), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    extractData(res) {
        let body = res;
        return body;
    }
    handleError(error) {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["throwError"])(error);
    }
};
IPAddressService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
IPAddressService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], IPAddressService);



/***/ }),

/***/ "./src/app/auth/_services/hmac-generation.service.ts":
/*!***********************************************************!*\
  !*** ./src/app/auth/_services/hmac-generation.service.ts ***!
  \***********************************************************/
/*! exports provided: HmacGenerationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HmacGenerationService", function() { return HmacGenerationService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! crypto-js/enc-base64 */ "./node_modules/crypto-js/enc-base64.js");
/* harmony import */ var crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _getIPaddress_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./getIPaddress.service */ "./src/app/auth/_services/getIPaddress.service.ts");



const CryptoJS = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");




let HmacGenerationService = class HmacGenerationService {
    constructor(http, ipaddress) {
        this.http = http;
        this.ipaddress = ipaddress;
        this._config = src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"];
        this.publicip = this._config.public_ip;
    }
    // verify() {
    //     return this.http.get('/api/verify', this.jwt()).map((response: Response) => response.json());
    // }
    hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                let method = "POST";
                let end_point = "/api/search_fuzzy/";
                let timestamp = new Date().toISOString();
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
        // return d_data;
    }
    sample_hmac_gen(keys) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = keys.user_seckey;
                let user_lkey = keys.user_lkey;
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "GET";
                let end_point = "/api/scrapper_monitor/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
        // let user_seckey = keys.user_seckey;
        // let user_lkey = keys.user_lkey;
        // let my_ip = this.publicip;
        // let method = "POST";
        // let end_point = "/api/search_fuzzy/";
        // let timestamp = new Date().toISOString();
        // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
        // let hmac = CryptoJS.algo.HMAC.create(
        //   CryptoJS.algo.SHA256,
        //   `${user_seckey}`
        // );
        // hmac.update(dd);
        // let hmacc = Base64.stringify(hmac.finalize());
        // return {
        //   h_macc: hmacc,
        //   u_lkey: user_lkey,
        //   timestamp: timestamp
        // };
    }
    scrapper_monitor_hmac_gen() {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "GET";
                let end_point = "/api/scrapper_monitor/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    post_delta_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "POST";
                let end_point = "/api/get_delta/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    run_scrapper_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "POST";
                let end_point = "/api/run_scrapper/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    validation_rule_hmac_gen() {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "GET";
                let end_point = "/api/validation_rules/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    watchlist_options_hmac_gen() {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "GET";
                let end_point = "/api/get_watchlist/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    watchlist_dropdown_options_hmac_gen() {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "GET";
                let end_point = "/api/watchlistoptions/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    developer_dropdown_options_hmac_gen() {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "GET";
                let end_point = "/api/developers/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    watchlist_hmac_gen() {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "GET";
                let end_point = "/api/watchlists/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    put_scrapper_monitor_hmac_gen(data, id) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "PUT";
                let end_point = "/api/scrapper_monitor/" + id;
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    put_validation_rule_hmac_gen(data, id) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "PUT";
                let end_point = "/api/validation_rules/" + id;
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    put_watchlist_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "PUT";
                let end_point = "/api/watchlists/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    put_scrapper_status_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "PUT";
                let end_point = "/api/watchlist_status/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    put_developer_status_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "PUT";
                let end_point = "/api/watchlist_assignee/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    add_validation_rule_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "POST";
                let end_point = "/api/validation_rules/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    add_watchlist_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                // my_ip = '192.168.137.4';
                let method = "POST";
                let end_point = "/api/watchlists/";
                // let timestamp = new Date().toISOString();
                let timestamp = '2019-11-25T10:55:51Z';
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    assets_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                let method = "POST";
                let end_point = "/api/get_assets/";
                let timestamp = new Date().toISOString();
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
        // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
        // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
        // let my_ip = this.publicip;
        // let method = "POST";
        // let end_point = "/api/get_assets/";
        // let timestamp = new Date().toISOString();
        // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
        // let hmac = CryptoJS.algo.HMAC.create(
        //   CryptoJS.algo.SHA256,
        //   `${user_seckey}`
        // );
        // hmac.update(dd);
        // let hmacc = Base64.stringify(hmac.finalize());
        // return {
        //   h_macc: hmacc,
        //   u_lkey: user_lkey,
        //   timestamp: timestamp
        // };
    }
    worksummary_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                let method = "POST";
                let end_point = "/api/get_work_summary/";
                let timestamp = new Date().toISOString();
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
        // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
        // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
        // let my_ip = this.publicip;
        // let method = "POST";
        // let end_point = "/api/get_work_summary/";
        // let timestamp = new Date().toISOString();
        // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
        // let hmac = CryptoJS.algo.HMAC.create(
        //   CryptoJS.algo.SHA256,
        //   `${user_seckey}`
        // );
        // hmac.update(dd);
        // let hmacc = Base64.stringify(hmac.finalize());
        // return {
        //   h_macc: hmacc,
        //   u_lkey: user_lkey,
        //   timestamp: timestamp
        // };
    }
    rca_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                let method = "POST";
                let end_point = "/api/get_rcas/";
                let timestamp = new Date().toISOString();
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
        // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
        // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
        // let my_ip = this.publicip;
        // let method = "POST";
        // let end_point = "/api/get_rcas/";
        // let timestamp = new Date().toISOString();
        // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
        // let hmac = CryptoJS.algo.HMAC.create(
        //   CryptoJS.algo.SHA256,
        //   `${user_seckey}`
        // );
        // hmac.update(dd);
        // let hmacc = Base64.stringify(hmac.finalize());
        // return {
        //   h_macc: hmacc,
        //   u_lkey: user_lkey,
        //   timestamp: timestamp
        // };
    }
    batch_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                let method = "POST";
                let end_point = "/api/batch_queue/";
                let timestamp = new Date().toISOString();
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
        // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
        // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
        // let my_ip = this.publicip;
        // let method = "POST";
        // let end_point = "/api/batch_queue/";
        // let timestamp = new Date().toISOString();
        // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
        // let hmac = CryptoJS.algo.HMAC.create(
        //   CryptoJS.algo.SHA256,
        //   `${user_seckey}`
        // );
        // hmac.update(dd);
        // let hmacc = Base64.stringify(hmac.finalize());
        // return {
        //   h_macc: hmacc,
        //   u_lkey: user_lkey,
        //   timestamp: timestamp
        // };
    }
    face_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                let method = "POST";
                let end_point = "/api/facesearch/";
                let timestamp = new Date().toISOString();
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    report_hmac_gen(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                let method = "POST";
                let end_point = "/api/report_pep/";
                let timestamp = new Date().toISOString();
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
    }
    get_by_job_id_hmac(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                let method = "POST";
                let end_point = "/api/batch_queue_search/";
                let timestamp = new Date().toISOString();
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
        // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
        // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
        // let my_ip = this.publicip;
        // let method = "POST";
        // let end_point = "/api/batch_queue_search/";
        // let timestamp = new Date().toISOString();
        // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
        // let hmac = CryptoJS.algo.HMAC.create(
        //   CryptoJS.algo.SHA256,
        //   `${user_seckey}`
        // );
        // hmac.update(dd);
        // let hmacc = Base64.stringify(hmac.finalize());
        // return {
        //   h_macc: hmacc,
        //   u_lkey: user_lkey,
        //   timestamp: timestamp
        // };
    }
    get_all_job_hmac(data) {
        return rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"].create(observer => {
            this.ipaddress.getIpAddress().subscribe(res => {
                let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
                let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
                let my_ip;
                my_ip = res["ip"];
                let method = "POST";
                let end_point = "/api/batch_queue_search/";
                let timestamp = new Date().toISOString();
                let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
                let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, `${user_seckey}`);
                hmac.update(dd);
                let hmacc = crypto_js_enc_base64__WEBPACK_IMPORTED_MODULE_3___default.a.stringify(hmac.finalize());
                observer.next({
                    h_macc: hmacc,
                    u_lkey: user_lkey,
                    timestamp: timestamp
                });
                observer.complete();
            }, err => {
                observer.next(err);
                observer.complete();
            });
        });
        // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
        // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
        // let my_ip = this.publicip;
        // let method = "POST";
        // let end_point = "/api/batch_queue_search/";
        // let timestamp = new Date().toISOString();
        // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
        // let hmac = CryptoJS.algo.HMAC.create(
        //   CryptoJS.algo.SHA256,
        //   `${user_seckey}`
        // );
        // hmac.update(dd);
        // let hmacc = Base64.stringify(hmac.finalize());
        // return {
        //   h_macc: hmacc,
        //   u_lkey: user_lkey,
        //   timestamp: timestamp
        // };
    }
};
HmacGenerationService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _getIPaddress_service__WEBPACK_IMPORTED_MODULE_6__["IPAddressService"] }
];
HmacGenerationService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], HmacGenerationService);



/***/ }),

/***/ "./src/app/auth/_services/index.ts":
/*!*****************************************!*\
  !*** ./src/app/auth/_services/index.ts ***!
  \*****************************************/
/*! exports provided: AlertService, AuthenticationService, UserService, HmacGenerationService, IPAddressService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _alert_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./alert.service */ "./src/app/auth/_services/alert.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AlertService", function() { return _alert_service__WEBPACK_IMPORTED_MODULE_1__["AlertService"]; });

/* harmony import */ var _authentication_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./authentication.service */ "./src/app/auth/_services/authentication.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AuthenticationService", function() { return _authentication_service__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"]; });

/* harmony import */ var _user_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./user.service */ "./src/app/auth/_services/user.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UserService", function() { return _user_service__WEBPACK_IMPORTED_MODULE_3__["UserService"]; });

/* harmony import */ var _hmac_generation_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./hmac-generation.service */ "./src/app/auth/_services/hmac-generation.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HmacGenerationService", function() { return _hmac_generation_service__WEBPACK_IMPORTED_MODULE_4__["HmacGenerationService"]; });

/* harmony import */ var _getIPaddress_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./getIPaddress.service */ "./src/app/auth/_services/getIPaddress.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IPAddressService", function() { return _getIPaddress_service__WEBPACK_IMPORTED_MODULE_5__["IPAddressService"]; });









/***/ }),

/***/ "./src/app/auth/_services/user.service.ts":
/*!************************************************!*\
  !*** ./src/app/auth/_services/user.service.ts ***!
  \************************************************/
/*! exports provided: UserService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserService", function() { return UserService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");



let UserService = class UserService {
    constructor(http) {
        this.http = http;
    }
};
UserService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
UserService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], UserService);



/***/ }),

/***/ "./src/app/auth/auth-routing.routing.ts":
/*!**********************************************!*\
  !*** ./src/app/auth/auth-routing.routing.ts ***!
  \**********************************************/
/*! exports provided: AuthRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthRoutingModule", function() { return AuthRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _auth_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./auth.component */ "./src/app/auth/auth.component.ts");




const routes = [
    { path: '', component: _auth_component__WEBPACK_IMPORTED_MODULE_3__["AuthComponent"] },
];
let AuthRoutingModule = class AuthRoutingModule {
};
AuthRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forChild(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]],
    })
], AuthRoutingModule);



/***/ }),

/***/ "./src/app/auth/auth.component.ts":
/*!****************************************!*\
  !*** ./src/app/auth/auth.component.ts ***!
  \****************************************/
/*! exports provided: AuthComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthComponent", function() { return AuthComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_authentication_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./_services/authentication.service */ "./src/app/auth/_services/authentication.service.ts");
/* harmony import */ var _services_alert_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./_services/alert.service */ "./src/app/auth/_services/alert.service.ts");
/* harmony import */ var _services_user_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./_services/user.service */ "./src/app/auth/_services/user.service.ts");
/* harmony import */ var ngx_ui_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-ui-loader */ "./node_modules/ngx-ui-loader/fesm2015/ngx-ui-loader.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./_services */ "./src/app/auth/_services/index.ts");
/* harmony import */ var _pages_api_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../pages/api.service */ "./src/app/pages/api.service.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");



// import { ScriptLoaderService } from '../_services/script-loader.service';



// import { LoginCustom } from './_helpers/login-custom';
// import { Helpers } from '../helpers';
// import 'rxjs/add/operator/catch';




let AuthComponent = class AuthComponent {
    // @ViewChild('alertSignin',
    //     { read: ViewContainerRef }) alertSignin: ViewContainerRef;
    // @ViewChild('alertSignup',
    //     { read: ViewContainerRef }) alertSignup: ViewContainerRef;
    // @ViewChild('alertForgotPass',
    //     { read: ViewContainerRef }) alertForgotPass: ViewContainerRef;
    constructor(_router, 
    // private _script: ScriptLoaderService,
    _userService, _route, _authService, _alertService, cfr, ngxService, hmacgen, Service, toastr) {
        this._router = _router;
        this._userService = _userService;
        this._route = _route;
        this._authService = _authService;
        this._alertService = _alertService;
        this.cfr = cfr;
        this.ngxService = ngxService;
        this.hmacgen = hmacgen;
        this.Service = Service;
        this.toastr = toastr;
        this.model = {};
        this.loading = false;
        this.error = '';
        this.disclaimer = false;
        this.suberror = [];
        this.alertpopup = false;
        this.messageAlert = '';
    }
    ngOnInit() {
        this.model.remember = true;
        this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
        this._router.navigate([this.returnUrl]);
        // this._script.loadScripts('body', [
        //     'assets/vendors/base/vendors.bundle.js',
        //     'assets/demo/demo10/base/scripts.bundle.js'], true).then(() => {
        //         // Helpers.setLoading(false);
        //         // LoginCustom.init();
        //     });
    }
    signin(formm) {
        this.ngxService.start();
        this.hmacgen.sample_hmac_gen({ user_seckey: this.secret_key, user_lkey: this.user_key }).subscribe(ress => {
            let fdata = {
                data: {},
                hmac_sig: ress.h_macc,
                u_key: ress.u_lkey,
                timestamp: ress.timestamp
            };
            this._authService.login(this.model.username, this.model.password).subscribe(data => {
                if (data) {
                    localStorage.setItem('currentUser', JSON.stringify(data));
                    localStorage.setItem('user_seckey', JSON.stringify(this.secret_key));
                    localStorage.setItem('user_lkey', JSON.stringify(this.user_key));
                    this.Service.getscrappermonitorlist(fdata).subscribe(res => {
                        this._router.navigate(['scrappermonitor']);
                        this.ngxService.stop();
                    }, error => {
                        // this.suberror = [];
                        //   if(error.error.error){
                        //     this.errortext = error.error.error
                        //   }else{
                        //     this.errortext = 'Something goes wrong';
                        //   }
                        // this.suberror.push({err: error.error.error})
                        this._router.navigate(['../logout']);
                        this.toastr.error(error.error.error);
                        // console.log(error.error.error);
                        this.ngxService.stop();
                    });
                    // Helpers.setLoading(false);
                    this.ngxService.stop();
                }
            }, error => {
                this.suberror = [];
                if (error.status == 0) {
                    this.showAlert('Service Temporarily Unavailable, please try again ');
                    this.outsession(error.status);
                    // for (const property in error.error) {
                    this.suberror.push({ err: "Unknown Error" });
                    //   }
                }
                else if (error.status == 400 || error.status == 401) {
                    this.showAlert('Invalid Credentials');
                    for (const property in error.error) {
                        this.suberror.push({ typ: property, err: error.error[property] });
                    }
                }
                else {
                    this.showAlert('Internal Server Error');
                    this.suberror.push({ err: "Internal Server Error" });
                }
                this.ngxService.stop();
            });
        }, err => {
            this.suberror = [];
            this.ngxService.stop();
            this.suberror.push({ err: "Something went wrong" });
        });
        // this.removeAlert();
        // Helpers.setLoading(true);
    }
    outsession(data) {
        if (data == 0) {
            localStorage.removeItem('currentUser');
            this._router.navigate(['/login']);
        }
    }
    removeAlert() {
        this.alertpopup = false;
        this.error = '';
    }
    showAlert(target) {
        this.alertpopup = true;
        this.error = target;
    }
};
AuthComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_user_service__WEBPACK_IMPORTED_MODULE_5__["UserService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _services_authentication_service__WEBPACK_IMPORTED_MODULE_3__["AuthenticationService"] },
    { type: _services_alert_service__WEBPACK_IMPORTED_MODULE_4__["AlertService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ComponentFactoryResolver"] },
    { type: ngx_ui_loader__WEBPACK_IMPORTED_MODULE_6__["NgxUiLoaderService"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_7__["HmacGenerationService"] },
    { type: _pages_api_service__WEBPACK_IMPORTED_MODULE_8__["ApiService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_9__["ToastrService"] }
];
AuthComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: '.m-grid.m-grid--hor.m-grid--root.m-page.h-100  ',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./templates/login-1.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/auth/templates/login-1.component.html")).default,
        encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./templates/login.component.scss */ "./src/app/auth/templates/login.component.scss")).default]
    })
], AuthComponent);



/***/ }),

/***/ "./src/app/auth/auth.module.ts":
/*!*************************************!*\
  !*** ./src/app/auth/auth.module.ts ***!
  \*************************************/
/*! exports provided: AuthModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthModule", function() { return AuthModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _auth_routing_routing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./auth-routing.routing */ "./src/app/auth/auth-routing.routing.ts");
/* harmony import */ var _auth_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./auth.component */ "./src/app/auth/auth.component.ts");
/* harmony import */ var _directives_alert_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./_directives/alert.component */ "./src/app/auth/_directives/alert.component.ts");
/* harmony import */ var _logout_logout_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./logout/logout.component */ "./src/app/auth/logout/logout.component.ts");
/* harmony import */ var _guards_auth_guard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./_guards/auth.guard */ "./src/app/auth/_guards/auth.guard.ts");
/* harmony import */ var _services_alert_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./_services/alert.service */ "./src/app/auth/_services/alert.service.ts");
/* harmony import */ var _services_authentication_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./_services/authentication.service */ "./src/app/auth/_services/authentication.service.ts");
/* harmony import */ var _services_user_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./_services/user.service */ "./src/app/auth/_services/user.service.ts");
/* harmony import */ var _interceptors_jwt_interceptor__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./interceptors/jwt.interceptor */ "./src/app/auth/interceptors/jwt.interceptor.ts");
/* harmony import */ var ngx_ui_loader__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ngx-ui-loader */ "./node_modules/ngx-ui-loader/fesm2015/ngx-ui-loader.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./_services */ "./src/app/auth/_services/index.ts");





// import { MockBackend } from '@angular/http/testing';











// import { fakeBackendProvider } from './_helpers/index';
// import { WebConfig } from '../WebConfig';
let AuthModule = class AuthModule {
};
AuthModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [
            _auth_component__WEBPACK_IMPORTED_MODULE_6__["AuthComponent"],
            _directives_alert_component__WEBPACK_IMPORTED_MODULE_7__["AlertComponent"],
            _logout_logout_component__WEBPACK_IMPORTED_MODULE_8__["LogoutComponent"],
        ],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClientModule"],
            _auth_routing_routing__WEBPACK_IMPORTED_MODULE_5__["AuthRoutingModule"],
            ngx_ui_loader__WEBPACK_IMPORTED_MODULE_14__["NgxUiLoaderModule"]
        ],
        providers: [
            _guards_auth_guard__WEBPACK_IMPORTED_MODULE_9__["AuthGuard"],
            _services_alert_service__WEBPACK_IMPORTED_MODULE_10__["AlertService"],
            _services_authentication_service__WEBPACK_IMPORTED_MODULE_11__["AuthenticationService"],
            _services_user_service__WEBPACK_IMPORTED_MODULE_12__["UserService"],
            _services__WEBPACK_IMPORTED_MODULE_15__["IPAddressService"],
            _services__WEBPACK_IMPORTED_MODULE_15__["HmacGenerationService"],
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HTTP_INTERCEPTORS"], useClass: _interceptors_jwt_interceptor__WEBPACK_IMPORTED_MODULE_13__["JwtInterceptor"], multi: true }
            // api backend simulation
            // fakeBackendProvider,
            // MockBackend,
            // BaseRequestOptions,
            // WebConfig,
        ],
    })
], AuthModule);



/***/ }),

/***/ "./src/app/auth/interceptors/jwt.interceptor.ts":
/*!******************************************************!*\
  !*** ./src/app/auth/interceptors/jwt.interceptor.ts ***!
  \******************************************************/
/*! exports provided: JwtInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JwtInterceptor", function() { return JwtInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");

// import 'rxjs/add/operator/do';




let JwtInterceptor = class JwtInterceptor {
    constructor(_router) {
        this._router = _router;
    }
    intercept(request, next) {
        return next.handle(request).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["tap"])((event) => {
            if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpResponse"]) {
                // do stuff with response if you want
            }
        }, (err) => {
            if (err instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpErrorResponse"]) {
                if (err.status == 401 && err.statusText == "Unauthorized") {
                    // redirect to the login route
                    // or show a modal
                    this._router.navigate(['../logout']);
                }
            }
        }));
    }
};
JwtInterceptor.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] }
];
JwtInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Injectable"])()
], JwtInterceptor);



/***/ }),

/***/ "./src/app/auth/logout/logout.component.ts":
/*!*************************************************!*\
  !*** ./src/app/auth/logout/logout.component.ts ***!
  \*************************************************/
/*! exports provided: LogoutComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogoutComponent", function() { return LogoutComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_authentication_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../_services/authentication.service */ "./src/app/auth/_services/authentication.service.ts");




// import { Helpers } from "../../helpers";
let LogoutComponent = class LogoutComponent {
    constructor(_router, _authService) {
        this._router = _router;
        this._authService = _authService;
    }
    ngOnInit() {
        // Helpers.setLoading(true);
        // reset login status
        this._authService.logout();
        this._router.navigate(['/login']);
    }
};
LogoutComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_authentication_service__WEBPACK_IMPORTED_MODULE_3__["AuthenticationService"] }
];
LogoutComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-logout',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./logout.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/auth/logout/logout.component.html")).default,
        encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
    })
], LogoutComponent);



/***/ }),

/***/ "./src/app/auth/templates/login.component.scss":
/*!*****************************************************!*\
  !*** ./src/app/auth/templates/login.component.scss ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("@import url(\"https://fonts.googleapis.com/css?family=Poppins\");\n/* theme */\n/* Login */\n/* Header */\n/* Left header background */\n/* Header Background Color */\n/* menu link color */\n/* menu link hover color */\n/* Left Panel */\n/* icon Background color*/\n/* Item Hover BG*/\n/* Item Hover Text Color*/\n/* Dropdown BG*/\n/* Dropdown Text Color  */\n/* Dropdown Text Color  */\n/* Dropdown dot bg hover*/\n/* Dropdown dot border hover*/\n/* Item Active BG */\n/* Right Panel */\n/* Footer */\n.leftPanel {\n  background-color: #f3f5f7;\n}\n.RightPanel {\n  background: url('splash.png') center center no-repeat;\n  background-size: cover;\n}\n.disclaimer {\n  line-height: 1.2rem;\n  font-size: 0.8rem;\n  padding: 1em;\n  background: #f1efef;\n}\n.disclaimer .disc-box {\n  max-height: 8rem;\n  border-top: 1px solid #cccccc;\n}\n.disclaimer .disc-box p {\n  padding: 0.5rem 0;\n}\nfooter {\n  font-size: 0.85em;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/no-internet/no-internet.component.scss":
/*!********************************************************!*\
  !*** ./src/app/no-internet/no-internet.component.scss ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL25vLWludGVybmV0L25vLWludGVybmV0LmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/no-internet/no-internet.component.ts":
/*!******************************************************!*\
  !*** ./src/app/no-internet/no-internet.component.ts ***!
  \******************************************************/
/*! exports provided: NoInternetComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoInternetComponent", function() { return NoInternetComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let NoInternetComponent = class NoInternetComponent {
    constructor() { }
    ngOnInit() {
    }
};
NoInternetComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-no-internet',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./no-internet.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/no-internet/no-internet.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./no-internet.component.scss */ "./src/app/no-internet/no-internet.component.scss")).default]
    })
], NoInternetComponent);



/***/ }),

/***/ "./src/app/p404/p404.component.scss":
/*!******************************************!*\
  !*** ./src/app/p404/p404.component.scss ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".ep {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background-color: #ecf0f8;\n  color: #212121;\n}\n.ep .er {\n  font-size: 20rem;\n  font-weight: 800;\n  margin-bottom: 0;\n}\n.ep .ertext {\n  font-size: 3rem;\n  font-weight: 400;\n  margin-bottom: 2rem;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcDQwNC9EOlxcUHJvamVjdHNcXHNjcmFwcGluZ19wb3J0YWxfdWkvc3JjXFxhcHBcXHA0MDRcXHA0MDQuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3A0MDQvcDQwNC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQTtFQUNJLGFBQUE7RUFDQSxtQkFBQTtFQUNBLHVCQUFBO0VBQ0Esc0JBQUE7RUFDQSx5QkFBQTtFQUNBLGNBQUE7QUNBSjtBRENJO0VBQ0ksZ0JBQUE7RUFDQSxnQkFBQTtFQUNBLGdCQUFBO0FDQ1I7QURDSTtFQUNJLGVBQUE7RUFDQSxnQkFBQTtFQUNBLG1CQUFBO0FDQ1IiLCJmaWxlIjoic3JjL2FwcC9wNDA0L3A0MDQuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJcclxuLmVwe1xyXG4gICAgZGlzcGxheTogZmxleDtcclxuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XHJcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcclxuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XHJcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWNmMGY4O1xyXG4gICAgY29sb3I6ICMyMTIxMjE7XHJcbiAgICAuZXJ7XHJcbiAgICAgICAgZm9udC1zaXplOiAyMHJlbTtcclxuICAgICAgICBmb250LXdlaWdodDogODAwO1xyXG4gICAgICAgIG1hcmdpbi1ib3R0b206IDA7XHJcbiAgICB9XHJcbiAgICAuZXJ0ZXh0e1xyXG4gICAgICAgIGZvbnQtc2l6ZTogM3JlbTtcclxuICAgICAgICBmb250LXdlaWdodDogNDAwO1xyXG4gICAgICAgIG1hcmdpbi1ib3R0b206IDJyZW07XHJcbiAgICB9XHJcbiAgfSIsIi5lcCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWNmMGY4O1xuICBjb2xvcjogIzIxMjEyMTtcbn1cbi5lcCAuZXIge1xuICBmb250LXNpemU6IDIwcmVtO1xuICBmb250LXdlaWdodDogODAwO1xuICBtYXJnaW4tYm90dG9tOiAwO1xufVxuLmVwIC5lcnRleHQge1xuICBmb250LXNpemU6IDNyZW07XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG4gIG1hcmdpbi1ib3R0b206IDJyZW07XG59Il19 */");

/***/ }),

/***/ "./src/app/p404/p404.component.ts":
/*!****************************************!*\
  !*** ./src/app/p404/p404.component.ts ***!
  \****************************************/
/*! exports provided: P404Component */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P404Component", function() { return P404Component; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let P404Component = class P404Component {
    constructor() { }
    ngOnInit() {
    }
};
P404Component = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-p404',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./p404.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/p404/p404.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./p404.component.scss */ "./src/app/p404/p404.component.scss")).default]
    })
], P404Component);



/***/ }),

/***/ "./src/app/p500/p500.component.scss":
/*!******************************************!*\
  !*** ./src/app/p500/p500.component.scss ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".ep {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background-color: #ecf0f8;\n  color: #212121;\n}\n.ep .er {\n  font-size: 20rem;\n  font-weight: 800;\n  margin-bottom: 0;\n}\n.ep .ertext {\n  line-height: 2rem;\n  font-size: 1.25rem;\n  font-weight: 400;\n  margin-bottom: 2rem;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcDUwMC9EOlxcUHJvamVjdHNcXHNjcmFwcGluZ19wb3J0YWxfdWkvc3JjXFxhcHBcXHA1MDBcXHA1MDAuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3A1MDAvcDUwMC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQTtFQUNJLGFBQUE7RUFDQSxtQkFBQTtFQUNBLHVCQUFBO0VBQ0Esc0JBQUE7RUFDQSx5QkFBQTtFQUNBLGNBQUE7QUNBSjtBRENJO0VBQ0ksZ0JBQUE7RUFDQSxnQkFBQTtFQUNBLGdCQUFBO0FDQ1I7QURDSTtFQUNJLGlCQUFBO0VBQ0Esa0JBQUE7RUFDQSxnQkFBQTtFQUNBLG1CQUFBO0FDQ1IiLCJmaWxlIjoic3JjL2FwcC9wNTAwL3A1MDAuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJcclxuLmVwe1xyXG4gICAgZGlzcGxheTogZmxleDtcclxuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XHJcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcclxuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XHJcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWNmMGY4O1xyXG4gICAgY29sb3I6ICMyMTIxMjE7XHJcbiAgICAuZXJ7XHJcbiAgICAgICAgZm9udC1zaXplOiAyMHJlbTtcclxuICAgICAgICBmb250LXdlaWdodDogODAwO1xyXG4gICAgICAgIG1hcmdpbi1ib3R0b206IDA7XHJcbiAgICB9XHJcbiAgICAuZXJ0ZXh0e1xyXG4gICAgICAgIGxpbmUtaGVpZ2h0OiAycmVtO1xyXG4gICAgICAgIGZvbnQtc2l6ZTogMS4yNXJlbTtcclxuICAgICAgICBmb250LXdlaWdodDogNDAwO1xyXG4gICAgICAgIG1hcmdpbi1ib3R0b206IDJyZW07XHJcbiAgICB9XHJcbiAgfSIsIi5lcCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWNmMGY4O1xuICBjb2xvcjogIzIxMjEyMTtcbn1cbi5lcCAuZXIge1xuICBmb250LXNpemU6IDIwcmVtO1xuICBmb250LXdlaWdodDogODAwO1xuICBtYXJnaW4tYm90dG9tOiAwO1xufVxuLmVwIC5lcnRleHQge1xuICBsaW5lLWhlaWdodDogMnJlbTtcbiAgZm9udC1zaXplOiAxLjI1cmVtO1xuICBmb250LXdlaWdodDogNDAwO1xuICBtYXJnaW4tYm90dG9tOiAycmVtO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/p500/p500.component.ts":
/*!****************************************!*\
  !*** ./src/app/p500/p500.component.ts ***!
  \****************************************/
/*! exports provided: P500Component */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500Component", function() { return P500Component; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let P500Component = class P500Component {
    constructor() { }
    ngOnInit() {
    }
};
P500Component = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-p500',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./p500.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/p500/p500.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./p500.component.scss */ "./src/app/p500/p500.component.scss")).default]
    })
], P500Component);



/***/ }),

/***/ "./src/app/pages/api.service.ts":
/*!**************************************!*\
  !*** ./src/app/pages/api.service.ts ***!
  \**************************************/
/*! exports provided: ApiService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApiService", function() { return ApiService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _app_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../app.service */ "./src/app/app.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");







let ApiService = class ApiService {
    // public faceurl = 'https://api.pakistanidentitycheck.com';
    constructor(service, http) {
        this.service = service;
        this.http = http;
        this.api = 'api';
        this.watchlist = 'api/watchlists';
        this.watch = 'api/watchlists/';
        this.scrapper_status = 'api/watchlist_status/';
        this.developer_status = 'api/watchlist_assignee/';
        this.narcolist = 'api/crimetype';
        this.serviceURIAUTH = 'auth';
        this.scrapper_monitor = 'api/scrapper_monitor/';
        this.post_delta = 'api/get_delta/';
        this.validation_rule = 'api/validation_rules/';
        this.scrapper_run = 'api/run_scrapper/';
        this.watchlist_options = 'api/get_watchlist/';
        this.watchlist_dropdown_options = 'api/watchlistoptions/';
        this.developer_dropdown_options = 'api/developers/';
        this.name_search = 'api/search_fuzzy/';
        this.fetch_assets = 'api/get_assets/';
        this.fetch_worksummary = 'api/get_work_summary/';
        this.fetch_RCA = 'api/get_rcas/';
        this.batch_file = 'api/batch_queue/';
        this.batch_job_id = 'api/batch_queue_search/';
        this._config = src_environments_environment__WEBPACK_IMPORTED_MODULE_6__["environment"];
        this.url = this._config.LFD;
        this.facescan_endpoint = 'api/facesearch/';
        this.apiUrl = 'https://api.pakistanidentitycheck.com/';
    }
    getwatchlist(params) {
        return this.service.get(`${this.watchlist}`, params);
    }
    getcrimedata(data) {
        return this.service.get(`${this.api}/crimetype/` + data);
    }
    getdetails(params) {
        return this.service.get(`api/pep-details/` + params);
    }
    // faceScan(facedata) : Observable<any>  {
    //     //   return this.service.post(this.facescan, facedata);
    //     return this.http.post(`${this.faceurl}` + this.facescan, facedata, this._header()).pipe(
    //         map(this.extractData)
    //         , catchError(this.handleError));
    // }
    me() {
        return this.service.get(`${this.serviceURIAUTH}/me/`);
    }
    postfacescan(params) {
        return this.service.post('/api/search_face', params);
    }
    namesearch(params) {
        return this.service.post(this.name_search, params);
    }
    getscrappermonitorlist(param) {
        return this.service.get(`${this.scrapper_monitor}`, param);
    }
    postdelta(param) {
        return this.service.post(`${this.post_delta}`, param);
    }
    getvalidationrulelist(param) {
        return this.service.get(`${this.validation_rule}`, param);
    }
    getwatchlistoptions(param) {
        return this.service.get(`${this.watchlist_options}`, param);
    }
    getwatchlistdropdownoptions(param) {
        return this.service.get(`${this.watchlist_dropdown_options}`, param);
    }
    getdeveloperdropdownoptions(param) {
        return this.service.get(`${this.developer_dropdown_options}`, param);
    }
    putscrappermonitorlist(param, itemid) {
        return this.service.put(`${this.scrapper_monitor}`, itemid, param);
    }
    putvalidationrulelist(param, itemid) {
        return this.service.put(`${this.validation_rule}`, itemid, param);
    }
    putwatchlist(param) {
        return this.service.put1(`${this.watch}`, param);
    }
    putscarpperstatus(param) {
        return this.service.put1(`${this.scrapper_status}`, param);
    }
    putdeveloperstatus(param) {
        return this.service.put1(`${this.developer_status}`, param);
    }
    addvalidationrulelist(params) {
        return this.service.post(`${this.validation_rule}`, params);
    }
    runscrapper(params) {
        return this.service.post(`${this.scrapper_run}`, params);
    }
    addwatchlist(params) {
        return this.service.post(`${this.watch}`, params);
    }
    fetchassets(params) {
        return this.service.post(this.fetch_assets, params);
    }
    fetchworksummary(params) {
        return this.service.post(this.fetch_worksummary, params);
    }
    fetchRCA(params) {
        return this.service.post(this.fetch_RCA, params);
    }
    fetchbatchjobbyid(params) {
        return this.service.post(this.batch_job_id, params);
    }
    postFile(fileToUpload, params) {
        const endpoint = `${this.url}${this.batch_file}`;
        const formData = new FormData();
        formData.append("csv", fileToUpload);
        // formData.append('report_name', filetype);
        // formData.append('Content-Type', fileToUpload.type);
        // formData.append('enctype ', 'multipart/form-data');
        return this.http
            .post(endpoint, formData, this.t_header(params))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(this.extractData), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    face_scan(item) {
        // return this.http.post(`${this.apiUrl}` + this.facescan_endpoint, item, { headers: this._header() }).pipe(
        //     map(this.extractData)
        //     ,catchError(this.handleError));
        return this.service.post(this.facescan_endpoint, item);
    }
    postreport(params) {
        return this.service.post('api/report_pep/', params);
    }
    _header() {
        let user = localStorage.getItem('currentUser');
        if (!!user) {
            let temp = JSON.parse(user);
            let token = temp['token'];
            // const headers = new HttpHeaders({ 
            //     // 'Access-Control-Allow-Origin': 'http://localhost:4200',
            //     // 'Access-Control-Allow-Credentials': 'true',
            //     // 'Access- Control-Allow-Headers': 'X-Requested-With, Content-Type',
            //     // 'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, DELETE',
            //     'Content-Type': 'application/json; charset=utf-8',
            //     'Authorization': 'jwt ' + token });
            // const options = { headers: headers };
            // return options;
            return new _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpHeaders"]({ 'Content-Type': 'application/json; charset=utf-8', Authorization: 'jwt ' + token });
        }
    }
    t_header(itm) {
        let user = localStorage.getItem('currentUser');
        if (!!user) {
            let temp = JSON.parse(user);
            let token = temp['token'];
            const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpHeaders"]({
                // 'Content-Type': 'application/json; charset=utf-8',
                // 'Access-Control-Allow-Origin': 'http://localhost:4200',
                // 'Access-Control-Allow-Credentials': 'true',
                // 'Access- Control-Allow-Headers': 'X-Requested-With, Content-Type',
                // 'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, DELETE',
                'Authorization': 'jwt ' + token,
                'Signature': itm.hmac_sig,
                'Key': itm.u_key,
                'timestamp': itm.timestamp,
                'Pragma': 'no-cache',
                'Cache-Control': 'no-cache, no-store, max-age=0, must-revalidate'
            });
            const options = { headers: headers };
            return options;
        }
    }
    extractData(res) {
        let body = res;
        return body;
    }
    handleError(error) {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["throwError"])(error);
    }
};
ApiService.ctorParameters = () => [
    { type: _app_service__WEBPACK_IMPORTED_MODULE_3__["AppService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClient"] }
];
ApiService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], ApiService);



/***/ }),

/***/ "./src/app/shared/directives/menudropdown.directive.ts":
/*!*************************************************************!*\
  !*** ./src/app/shared/directives/menudropdown.directive.ts ***!
  \*************************************************************/
/*! exports provided: MenudropdownDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MenudropdownDirective", function() { return MenudropdownDirective; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let MenudropdownDirective = class MenudropdownDirective {
    // @HostListener('mouseover') onMouseHover() {
    //   this.isOpen = ! this.isOpen;
    // }
    // @HostListener('mouseleave') onMouseleave() {
    //   this.isOpen = ! this.isOpen;
    // }
    constructor(elRef, renderer) {
        this.elRef = elRef;
        this.renderer = renderer;
        this.isOpen = false;
    }
    toggleOpen() {
        const elements = document.getElementsByClassName('menu-item');
        const parentElm = this.renderer.parentNode(this.elRef.nativeElement);
        const elm = this.elRef.nativeElement;
        if (elm.classList.contains('open')) {
            this.renderer.removeClass(elm, 'open');
            this.isOpen = !this.isOpen;
        }
        else {
            for (const elem of elements) {
                elem.classList.remove('open');
            }
            if (elm.classList.contains('hasMenu')) {
                this.renderer.addClass(elm, 'open');
                this.isOpen = true;
            }
        }
    }
};
MenudropdownDirective.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Renderer2"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostBinding"])('class.open')
], MenudropdownDirective.prototype, "isOpen", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('click')
], MenudropdownDirective.prototype, "toggleOpen", null);
MenudropdownDirective = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"])({
        selector: '[appMenudropdown]',
    })
], MenudropdownDirective);



/***/ }),

/***/ "./src/app/shared/services/layout.service.ts":
/*!***************************************************!*\
  !*** ./src/app/shared/services/layout.service.ts ***!
  \***************************************************/
/*! exports provided: LayoutService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutService", function() { return LayoutService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");



let LayoutService = class LayoutService {
    constructor() {
        this.rSidebarToggleStatus = false;
        // Commaon Settings for Horizontal and Vertical Navigation
        this.navLayout = 'vertical'; // Value Should be 'horizontal' or 'vertical'
        this.toggleStatus = false; // Value Should be 'true' or 'false'
        this.toggleSideStatus = true; // Value Should be 'true' or 'false'
        this.themeLayout = 'wide'; // value Should be 'wide', 'box'
        this.headerHeight = 60;
        this.asidebarHeight = window.innerHeight;
        this.contentHeight = window.innerHeight - this.headerHeight;
        this.headerColorTheme = 'theme1';
        this.leftHeaderColorTheme = 'theme2';
        this.navbarColorTheme = 'theme2';
        this.activeNavColorTheme = 'theme1';
        // Setting Only for Vertical
        this.collapsedLeftHeader = false; // valshould be true, false
        this.toggleOnHover = true;
        // defaultVerticalMenu[0] = Default menu on mobile
        // defaultVerticalMenu[1] = Default menu on tablet
        // defaultVerticalMenu[2] = Default menu on desktop
        this.defaultVerticalMenu = ['offcanvas', 'collapsed', 'expanded'];
        // onToggleVerticalMenu[0] = Toggle menu on mobile
        // onToggleVerticalMenu[1] = Toggle menu on tablet
        // onToggleVerticalMenu[2] = Toggle menu on desktop
        this.onToggleVerticalMenu = ['expanded', 'expanded', 'collapsed'];
        // navBarMenuEffect[0] = Sidebar Toggle effect on mobile
        // navBarMenuEffect[1] = Sidebar Toggle effect on tablet
        // navBarMenuEffect[2] = Sidebar Toggle effect on desktop
        this.navBarMenuEffect = ['overlay', 'push', 'shrink'];
        // defaultDeviceType[0] = breakpoint for Mobile
        // defaultDeviceType[1] = breakpoint for tablet
        // defaultDeviceType[2] = breakpoint for desktop
        this.defaultDeviceType = ['mobile', 'tablet', 'desktop'];
        this.setNavLayout = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.navLayout);
        this.navLayoutCast = this.setNavLayout.asObservable();
        this.setCollapsedLeftHeader = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.collapsedLeftHeader);
        this.collapsedLeftHeaderCast = this.setCollapsedLeftHeader.asObservable();
        this.tStatus = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.toggleStatus);
        this.tStatusCast = this.tStatus.asObservable();
        this.dfNavbar = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.defaultNavbar);
        this.dfNavbarCast = this.dfNavbar.asObservable();
        this.tNavbar = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.toggleNavbar);
        this.toggleNavbarCast = this.tNavbar.asObservable();
        this.nvEffect = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.navBarEffect);
        this.nvEffectCast = this.nvEffect.asObservable();
        this.setCtHeight = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.contentHeight);
        this.contentHeightCast = this.setCtHeight.asObservable();
        this.setAsidebarHeight = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.asidebarHeight);
        this.setAsidebarHeightCast = this.setAsidebarHeight.asObservable();
        this.setHeaderTheme = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.headerColorTheme);
        this.headerThemeCast = this.setHeaderTheme.asObservable();
        this.setLeftHeaderTheme = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.leftHeaderColorTheme);
        this.leftHeaderThemeCast = this.setLeftHeaderTheme.asObservable();
        this.setNavbarTheme = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.navbarColorTheme);
        this.navbarThemeCast = this.setNavbarTheme.asObservable();
        this.SetActiveNavTheme = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.activeNavColorTheme);
        this.activeNavThemeCast = this.SetActiveNavTheme.asObservable();
        this.SetThemeLayout = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.themeLayout);
        this.themeLayoutCast = this.SetThemeLayout.asObservable();
        this.appDeviceType = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.deviceType);
        this.deviceTypeCast = this.appDeviceType.asObservable();
        this.rsToggleStatus = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](this.rSidebarToggleStatus);
        this.rsToggleStatusCast = this.rsToggleStatus.asObservable();
    }
    getToggleStatus() {
        this.toggleStatus = !this.toggleStatus;
        this.tStatus.next(this.toggleStatus);
    }
    getDefaultNavbar(defaultNavbar) {
        this.dfNavbar.next(defaultNavbar);
    }
    getToggleNavbar(toggleNavbar) {
        this.tNavbar.next(toggleNavbar);
    }
    getNavBarEffect(navbarEffect) {
        this.nvEffect.next(navbarEffect);
    }
    getDeviceType(dt) {
        this.appDeviceType.next(dt);
    }
    getThemeLayout(tl) {
        this.SetThemeLayout.next(tl);
    }
    getCollapsedLeftHeader(clh) {
        this.setCollapsedLeftHeader.next(clh);
    }
    getNavLayout(nl) {
        this.setNavLayout.next(nl);
    }
    getLeftHeaderThemeOnChange(themeName) {
        this.setLeftHeaderTheme.next(themeName);
    }
    getHeaderThemeOnChange(themeName) {
        this.setHeaderTheme.next(themeName);
    }
    getAsidebarThemeOnChange(themeName) {
        this.setNavbarTheme.next(themeName);
    }
    // This function called from page Core component load and resize
    checkWindowWidth(windowWidth) {
        if (this.navLayout === 'vertical') {
            if (windowWidth >= 768 && windowWidth <= 1024) {
                this.defaultNavbar = this.defaultVerticalMenu[1];
                this.toggleNavbar = this.onToggleVerticalMenu[1];
                this.navBarEffect = this.navBarMenuEffect[1];
                this.deviceType = this.defaultDeviceType[1];
            }
            else if (windowWidth < 768) {
                this.defaultNavbar = this.defaultVerticalMenu[0];
                this.toggleNavbar = this.onToggleVerticalMenu[0];
                this.navBarEffect = this.navBarMenuEffect[0];
                this.deviceType = this.defaultDeviceType[0];
            }
            else {
                this.defaultNavbar = this.defaultVerticalMenu[2];
                this.toggleNavbar = this.onToggleVerticalMenu[2];
                this.navBarEffect = this.navBarMenuEffect[2];
                this.deviceType = this.defaultDeviceType[2];
            }
        }
        else if (this.navLayout === 'horizontal') {
            if (windowWidth >= 768 && windowWidth <= 1024) {
                this.deviceType = this.defaultDeviceType[1];
            }
            else if (windowWidth < 768) {
                this.deviceType = this.defaultDeviceType[0];
            }
            else {
                this.deviceType = this.defaultDeviceType[2];
            }
        }
        this.getDefaultNavbar(this.defaultNavbar);
        this.getToggleNavbar(this.toggleNavbar);
        this.getNavBarEffect(this.navBarEffect);
        this.getDeviceType(this.deviceType);
    }
    getVerticalNavbarOnWindowResize(windowWidth) {
        this.checkWindowWidth(windowWidth);
    }
};
LayoutService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], LayoutService);



/***/ }),

/***/ "./src/app/shared/shared.module.ts":
/*!*****************************************!*\
  !*** ./src/app/shared/shared.module.ts ***!
  \*****************************************/
/*! exports provided: SharedModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SharedModule", function() { return SharedModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _services_layout_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./services/layout.service */ "./src/app/shared/services/layout.service.ts");
/* harmony import */ var _directives_menudropdown_directive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./directives/menudropdown.directive */ "./src/app/shared/directives/menudropdown.directive.ts");
var SharedModule_1;






let SharedModule = SharedModule_1 = class SharedModule {
    static forRoot() {
        return {
            ngModule: SharedModule_1,
            providers: [
                _services_layout_service__WEBPACK_IMPORTED_MODULE_4__["LayoutService"],
            ]
        };
    }
};
SharedModule = SharedModule_1 = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [
            _directives_menudropdown_directive__WEBPACK_IMPORTED_MODULE_5__["MenudropdownDirective"]
        ],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormsModule"]
        ],
        exports: [
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormsModule"],
            _directives_menudropdown_directive__WEBPACK_IMPORTED_MODULE_5__["MenudropdownDirective"]
        ],
    })
], SharedModule);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    LFD: 'https://scrap-mon-api.lfdanalytics.com/',
    // LFD: 'http://104.248.62.74:8200/',
    public_ip: '122.8.79.42'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! D:\Projects\scrapping_portal_ui\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map